import React from 'react';
import './GroupImage.css';

function GroupImageEn() {
  return (
    <section className="group-image-section">
      <div className="container">
        <div className="group-image-wrapper">
          <img src={`${process.env.PUBLIC_URL}/grupo-tabia.jpg`} alt="Tabia Group" />
        </div>
      </div>
    </section>
  );
}

export default GroupImageEn;
